<template>
  <div>
    <div id="top-menu">
      <b-navbar toggleable="md">
        <a href="/padmin" id="passman-logo"></a>
        <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>

        <b-navbar-brand href="#">
          <div id="version" v-if="padminVersion">
            {{padminVersion}}
          </div>
        </b-navbar-brand>

        <b-collapse is-nav id="nav_collapse">
          <b-navbar-nav class="ml-auto">
            <b-nav-item-dropdown right class="navbar-user-menu" id="user-menu">
              <template slot="button-content">
                <span v-if="currentUser">
                  {{currentUser.username}}
                </span>
                <span v-else>User</span>
              </template>
              <b-dropdown-item class="user-menu-item" id="current-language">
                <div class="dropdown-submenu">
                  <div class="dropdown-toggle" data-toggle="dropdown" @click.stop="langSelectorShown=!langSelectorShown">
                    {{$t("message.language") | capitalize}}: {{$t("message.language_" + currentLanguage) | capitalize }}
                  </div>
                  <ul v-if="langSelectorShown && supportedLanguages" id="language-menu" class="dropdown-menu">
                    <li class="dropdown-item" v-for="lang in supportedLanguages" @click="changeLang(lang)" :key="lang">
                      <div v-if="lang == currentLanguage" class="active-language">
                        <font-awesome-icon icon="check" id="active-language-icon"/>
                        {{$t("message.language_" + lang) | capitalize}}
                      </div>
                      <div v-else class="nonactive-language">
                        {{$t("message.language_" + lang) | capitalize}}
                      </div>
                    </li>
                  </ul>
                </div>
              </b-dropdown-item>

              <b-dropdown-item v-if="currentUser" @click="changeOwnPassword" id="change-password">
                {{ $t("message.change_password") | capitalize }}
              </b-dropdown-item>

              <b-dropdown-item  @click="logout()" class="user-menu-item" id="logout">
                {{ $t("message.logout") | title }}
              </b-dropdown-item>
            </b-nav-item-dropdown>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
    </div>
  </div>
</template>

<script>
import { i18n } from '../main'
import { post } from '../http'
import { EventBus } from '../event-bus.js'

export default {
  name: 'TopMenu',

  props: {
    currentUser: Object,
    padminVersion: String,
    supportedLanguages: [String]
  },

  data () {
    return {
      langSelectorShown: false
    }
  },

  computed: {
    currentLanguage () {
      return i18n.locale
    }
  },

  methods: {
    logout () {
      EventBus.$emit('logged out')
    },

    changeOwnPassword() {
      EventBus.$emit('change own password')
    },

    changeLang (lang) {
      i18n.locale = lang
      this.langSelectorShown = false
    }
  }
}

</script>

<style>
  @import "./../styles/topMenuComponent.css";
</style>
